/* Global imports. */
import React from "react";
import { Link } from "gatsby"

interface Props {
  bannerType?: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
  imageUrl: string;
  imagePlacement?: string;
  textPlacementClass?: string;
  primaryTextColour?: string;
  backgroundColour?: string;
  backgroundColourLeft?: string;
  backgroundColourRight?: string;
  componentID?: string;
  referringSlug?: string
}

function BannerComplex({bannerType, title, text, buttonText, buttonUrl, imageUrl, imagePlacement, textPlacementClass, primaryTextColour, backgroundColour, backgroundColourLeft, backgroundColourRight, componentID, referringSlug}: Props) {
  const bannerTypeBackgroundImage = "background_image"

  const bannerBackgroundImageStyle = {
    backgroundImage: bannerType === bannerTypeBackgroundImage || bannerType === undefined ? `url(${imageUrl})` : "none",
    backgroundColor: `${backgroundColour}`,
  }

  const textStyle = {
    color: primaryTextColour
  }

  const bannerTypeFlexible = "flexible";
  const bannerIsFlexible = bannerType === bannerTypeFlexible
  const bannerFlexibleClasses = "relative left-[50%] right-[50%] mb-8 ml-[-50vw] mr-[-50vw] max-w-[100vw] w-[100vw]";
  const bannerConstrainedClasses = "relative mb-8 max-full w-full";
  const textColour = primaryTextColour ? `text-white md:text-[${primaryTextColour}]` : ""

  return <div id={componentID} data-component="banner" className={bannerIsFlexible ? bannerFlexibleClasses : bannerConstrainedClasses} >
  <div className={bannerIsFlexible ? "ml-auto mr-auto max-w-lg pl-8 pr-8" : "max-full w-full"}>
    <section className="relative flex w-full justify-left">
      {backgroundColourLeft !== "transparent" && <span className="ml-[-50vw] w-[100vw] bottom-0 left-0 absolute right-2/4 top-0 z-0" style={{backgroundColor: `${backgroundColourLeft}`}} />}
      {backgroundColourRight !== "transparent" && <span className="mr-[-50vw] w-[100vw] bottom-0 right-0 absolute left-2/4 top-0 z-0" style={{backgroundColor: `${backgroundColourRight}`}} />}
        <div className="relative z-50 grid w-full grid-cols-1 sm:grid-cols-2">
          <div className={imagePlacement === "left" ? "w-full sm:w-auto  sm:col-start-1 sm:row-start-1" : "w-full sm:w-auto sm:col-start-2 sm:row-start-1"}>
          {imageUrl && <img src={imageUrl} alt="" />}
          </div>
          <div className={`items-start flex flex-col justify-center h-full py-8 sm:p-8 ${imagePlacement === "left" ? "sm:col-start-2 sm:row-start-1" : "col-start-1 row-start-1"}`}>
            <h1 className={`mb-6 text-2xl sm:text-[56px] leading-[40px] sm:leading-[68px]`} style={textStyle}>{title}</h1>
            <span className={`mb-6 font-serif text-base`} style={textStyle}  dangerouslySetInnerHTML={{ __html: text }}/>
            {buttonUrl && buttonText && <Link data-title={title} data-ref-slug={referringSlug} data-component="banner" data-componentID={componentID} to={`${buttonUrl}`} className="ml-0 button hover:!border-transparent">{buttonText}</Link>}
          </div>
        </div>
    </section>
  </div>
</div>
}

export default BannerComplex;